import React from 'react';
import { Row, Image } from "react-bootstrap";
import i18n from "../../I18n";
import CheckedRadio from '../../assets/images/checked_radio.svg';
import UncheckedRadio from '../../assets/images/unchecked_radio.svg';
import OutOfStockRadio from '../../assets/images/out_of_stock_radio.svg';

const TimeSlotPicker = ({
  language,
  isConfirm,
  timeSlots,
  onTimeSlotSelect,
  selectedTimeSlotId,
}) => {
  const onClick = (slot) => {
    if (isConfirm) {
      return;
    };
    if (!slot.stockCount) {
      return;
    };
    onTimeSlotSelect(slot.id);
  };

  return (
    <div className='slot_picker_container'>
      <Row>
        <label className="slot_picker_title headline">
          {i18n.t("timeSlot")}
        </label>
      </Row>
      <div id="slot_list" className="overflow-auto">
        {
          timeSlots?.map((slot, index) => {
            const available = slot.stockCount;
            const isSelected = slot.id === selectedTimeSlotId;
            let image = OutOfStockRadio;
            if (available) {
              image = UncheckedRadio;
            };
            if (isSelected) {
              image = CheckedRadio;
            };

            if (isConfirm && !isSelected) {
              return null;
            };
            return (
              <div
                onClick={() => onClick(slot)}
                className="slot_list_item"
              >
                <div>
                  <Image
                    src={image}
                    className={`slot_list_item_image ${
                      available ? 'available-icon-filter' : 'unavailable-icon-filter'
                    } ${
                      isConfirm ? 'slot_list_item_image_none' : ''
                    }`}
                  />
                </div>
                <div>
                  <div className={`slot_name ${isConfirm ? "slot_name_confirm": ""} body-2`}>{slot.title}</div>
                  {!slot.stockCount && (
                    <span className="badge available_state_label slot_out_of_stock caption">
                      {i18n.t("product:Out of stock")}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  )
};

export default TimeSlotPicker;
